import Vue from "vue";
import VueRouter from "vue-router";
import GmbAuthentication from "@/views/Authentication/Authentication";
import GmbObservatory from "@/views/Observatory/Observatory";

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "Observatory",
        component: GmbObservatory,
        props: (route) => ({activatedEntityIdentifierFromUrl: route.query.entity}),
    },
    {
        path: "/authentication/",
        name: "Authentication",
        component: GmbAuthentication,
    },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});

export default router;
